
import HomeSlider from "../../components/home-slider";
import OurNews from "../../components/our-news";
import OurProcess from "../../components/our-process";
import OurMedia from "../../components/our-media";
import './home.scss'
const Home = () => {
  return (
    <>


    <HomeSlider/>
    <OurProcess/>
    <OurNews/>
    <OurMedia/>

      
    </>
  );
};

export default Home;
